import React from 'react';
import _ from 'lodash';
import { InputContainer } from '../../../../../../common/components/form/form.module';


let currentChange: any = {}
const TicketActivityComponent = ({
  ticketStatus, ticketActivityType, resolutionAction, selectedActivitiy, onFormItemChange, itemIndex,
  accountTypesList,accountsList}: any) => {
  return (
    <>
      <div className="bg-white shadow-md rounded p-4 mb-4">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
          <InputContainer
            isDisabled={selectedActivitiy?.Id !== 0}
            label="Ticket Activity Type"
            labelField="Text"
            list={ticketActivityType}
            onValueChange={(event: any, newValue: any) => {
              onFormItemChange({ value: event.target.value, field: 'TicketActivityTypeId', idx: itemIndex });
            }}
            optionName='Choose TicketActivityType'
            type="select"
            value={selectedActivitiy?.TicketActivityTypeId}
            valueField="Value"
          />
          <InputContainer
            isDisabled={selectedActivitiy?.Id !== 0}
            label="Activity Status"
            labelField="Text"
            list={ticketStatus}
            onValueChange={(event: any, newValue: any) => {
              onFormItemChange({ value: event.target.value, field: 'ActivityStatusId', idx: itemIndex });
            }}
            optionName='Choose ActivityStatus'
            type="select"
            value={selectedActivitiy?.ActivityStatusId}
            valueField="Value"
          />
          {selectedActivitiy?.ActivityStatusId === 22 &&
          <InputContainer
            isDisabled={selectedActivitiy?.Id !== 0}
            label="Cascaded AccountType"
            labelField="Name"
            list={accountTypesList}
            onValueChange={(event: any) => {
              onFormItemChange({
                value: event.target.value,
                field: 'CascadedAccountTypeId',
                idx: itemIndex
              });
            }}
            optionName='Choose Account Type'
            type="select"
            value={selectedActivitiy?.CascadedAccountTypeId}
            valueField="Id"
          />}
          {selectedActivitiy?.ActivityStatusId === 22 &&
          <InputContainer
            isDisabled={selectedActivitiy?.Id !== 0}
            label="Cascaded AccountName"
            labelField="Name"
            list={accountsList}
            onValueChange={(event: any) => {
              onFormItemChange({
                value: event.target.value,
                field: 'CascadedAccountId',
                idx: itemIndex
              });
            }}
            optionName='Choose Account Name'
            type="select"
            value={selectedActivitiy?.CascadedAccountId}
            valueField="Id"
          />}
          <InputContainer
            isDisabled={selectedActivitiy?.Id !== 0}
            label="Response"
            name="IsResponse"
            onValueChange={(event: any) => {
              onFormItemChange({ value: event, field: 'IsResponse', idx: itemIndex });
            }}
            type="checkbox"
            value={selectedActivitiy?.IsResponse}
          />
          <InputContainer
            isDisabled={selectedActivitiy?.Id !== 0}
            label="Visible To Requestor"
            name="IsVisibleToRequestor"
            onValueChange={(event: any) => {
              onFormItemChange({ value: event, field: 'IsVisibleToRequestor', idx: itemIndex });
            }}
            type="checkbox"
            value={selectedActivitiy?.IsVisibleToRequestor}
          />
          <InputContainer
            isDateTimePicker
            isDisabled={selectedActivitiy?.Id !== 0}
            label="Start Time"
            name="StartTimeOnUtc"
            onValueChange={(event: any) => {
              onFormItemChange({ value: event.target.value, field: 'StartTimeOnUtc', idx: itemIndex });
            }}
            type="date"
            value={selectedActivitiy?.StartTimeOnUtc}
          />
          <InputContainer
            isDateTimePicker
            isDisabled={selectedActivitiy?.Id !== 0}
            label="End Time"
            name="StopTimeOnUtc"
            onValueChange={(event: any) => {
              onFormItemChange({ value: event.target.value, field: 'StopTimeOnUtc', idx: itemIndex });
            }}
            type="date"
            value={selectedActivitiy?.StopTimeOnUtc}
          />
          {selectedActivitiy?.ActivityStatusId === 60 && (
            <>
              <InputContainer
                isDisabled={selectedActivitiy?.Id !== 0}
                label="Resolution Action"
                labelField="Text"
                list={resolutionAction}
                onValueChange={(event: any, newValue: any) => {
                  onFormItemChange({ value: event.target.value, field: 'ActionTypeId', idx: itemIndex });
                }}
                optionName='Choose ActionType'
                type="select"
                value={selectedActivitiy?.ActionTypeId}
                valueField="Value"
              />
              {selectedActivitiy?.ActionTypeId === 10 && (
                <InputContainer
                  isDisabled={selectedActivitiy?.Id !== 0}
                  label="Refund Amount"
                  name="RefundAmount"
                  onValueChange={(event: any) => {
                    onFormItemChange({ value: event.target.value, field: 'RefundAmount', idx: itemIndex });
                  }}
                  type="text"
                  value={selectedActivitiy?.RefundAmount}
                />
              )}
              <div className="col-span-full">
                <InputContainer
                  isDisabled={selectedActivitiy?.Id !== 0}
                  label="Subject"
                  name="Subject"
                  onValueChange={(event: any) => {
                    onFormItemChange({ value: event.target.value, field: 'Subject', idx: itemIndex });
                  }}
                  type="text"
                  value={selectedActivitiy?.Subject}
                />
              </div>

            </>
          )}
          <div className="col-span-full">
            <InputContainer
              isDisabled={selectedActivitiy?.Id !== 0}
              label="Description"
              name="Description"
              onValueChange={(event: any) => {
                onFormItemChange({ value: event.target.value, field: 'Description', idx: itemIndex });
              }}
              type="text"
              value={selectedActivitiy?.Description}
            />
          </div>

        </div>
      </div>
    </>
  );
};

export default TicketActivityComponent;
